module.exports = __webpack_public_path__ + "static/media/interview12.b1cbd786.jpg";